import { promotions } from '@/mocks/homeData';

export default function PromotionSection() {
  return (
    <section id="promotions" className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            超值<strong className="text-accent-500">优惠活动</strong>
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            丰富福利持续放送，让您的游戏体验更加超值
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {promotions.map((promo) => (
            <div
              key={promo.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 transition-all duration-300"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={promo.image}
                  alt={promo.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold text-background-50 bg-gradient-to-r ${promo.color}`}>
                    {promo.tag}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                  {promo.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {promo.description}
                </p>
                <a
                  href="#"
                  className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  立即参与
                  <i className="ri-arrow-right-line text-xs"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}